<template>
  <div class="app-container">
    <div class="filter-container" >
      <el-input class="filter-item" v-model="listQuery.user_id" placeholder="用户ID" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.nickname" placeholder="用户昵称" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.phone" placeholder="用户手机号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.link_phone" placeholder="预定人手机号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.order_no" placeholder="订单号" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.hotel_name" placeholder="酒店名称" style="width: 220px;"
                clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_name" placeholder="房型名称名称" style="width: 220px;"
                clearable size="small"/>

      <el-select class="filter-item" v-model="listQuery.status" placeholder="订单状态" style="width: 160px" clearable size="small">
        <el-option label="未支付" :value="0"/>
        <el-option label="预订成功" :value="1"/>
        <el-option label="已取消" :value="2"/>
        <el-option label="预订未到" :value="3"/>
        <el-option label="已入住" :value="4"/>
        <el-option label="已完成" :value="5"/>
        <el-option label="已关闭" :value="6"/>
      </el-select>


      <el-select class="filter-item" v-model="listQuery.pay_status" placeholder="支付状态" style="width: 160px"
                 clearable size="small">
        <el-option label="待支付" :value="1"/>
        <el-option label="支付成功" :value="2"/>
        <el-option label="支付失败" :value="3"/>
        <el-option label="支付取消" :value="4"/>
      </el-select>

      <el-select class="filter-item" v-model="listQuery.comment_status" placeholder="评价状态" style="width: 160px"
                 clearable size="small">
        <el-option label="已评价" :value="1"/>
        <el-option label="未评价" :value="0"/>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.refund_status" placeholder="退款状态" style="width: 160px"
                 clearable size="small">
        <el-option label="未退款" :value="0"/>
        <el-option label="退款中" :value="1"/>
        <el-option label="退款成功" :value="2"/>
        <el-option label="退款失败" :value="3"/>
      </el-select>


      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row
              :row-class-name="errorRow">
      <el-table-column label="ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="用户头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.user.avatar" class="user-avatar">
        </template>
      </el-table-column>
      <el-table-column label="用户昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{  scope.row.user?scope.row.user.nickname:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="用户手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{  scope.row.user?scope.row.user.phone:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="预定人手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.link_phone }}
        </template>
      </el-table-column>
      <el-table-column label="酒店名称" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel ? scope.row.hotel.inn_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型名称" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type ? scope.row.room_type.room_type_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="下单时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_date }}
        </template>
      </el-table-column>

      <el-table-column label="总金额" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_money }}
        </template>
      </el-table-column>

      <el-table-column label="总成本金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_cost_money }}
        </template>
      </el-table-column>

      <el-table-column label="入住时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.travel_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_travel_date }}
        </template>
      </el-table-column>


      <el-table-column label="房间间数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.ticket_num }}
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.status === 0">未支付</el-tag>
          <el-tag type="primary" v-if="scope.row.status === 1">预订成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status === 2">已取消</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status === 3">预订未到</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status === 4">已入住</el-tag>
          <el-tag type="success" v-else-if="scope.row.status === 5">已完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status === 6">已关闭</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_status === 1">待支付</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_status === 2">支付成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 3">支付失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 4">支付取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_at }}
        </template>
      </el-table-column>
      <el-table-column label="评价状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.comment_status === 1">已评价</el-tag>
          <el-tag type="warning" v-else-if="scope.row.comment_status === 0">未评价</el-tag>

        </template>
      </el-table-column>
      <el-table-column label="评价时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.comment_at }}
        </template>
      </el-table-column>
      <el-table-column label="退款状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.refund_status === 0">未退款</el-tag>
          <el-tag type="warning" v-else-if="scope.row.refund_status === 1">退款中</el-tag>
          <el-tag type="success" v-else-if="scope.row.refund_status === 2">退款成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.refund_status === 3">退款失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="退款时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.refund_at }}
        </template>
      </el-table-column>
      <el-table-column label="取消时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.cancel_at }}
        </template>
      </el-table-column>
      <el-table-column label="操作处理失败信息" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.handle_error_message }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleCancelOrder(scope.row)"
                     :disabled="!(scope.row.pay_status === 1)">取消订单
          </el-button>
          <el-button type="warning" size="mini" @click="refund(scope.row)"
                     :disabled="(scope.row.pay_status != 2||scope.row.refund_status == 2)">退款
          </el-button>

<!--          <el-button type="warning" size="mini" @click="handleComplete(scope.row)"-->
<!--                     :disabled="handleCompleteStatus(scope.row)">处理完成-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 修改到店时间 -->
    <el-dialog title="修改到店时间" :visible.sync="dialogVisibleModifyLastArrTime" width="60%"
               :close-on-click-modal="false">
      <el-form ref="modifyLastArrTimeForm" :rules="modifyLastArrTimeRules" :model="modifyLastArrTimeForm"
               label-width="150px">
        <el-form-item label="修改到店时间" prop="last_arr_time">
          <el-date-picker v-model="modifyLastArrTimeForm.last_arr_time" type="datetime" placeholder="选择日期时间"
                          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleModifyLastArrTime = false">取消</el-button>
        <el-button type="primary" @click="saveDataModifyLastArrTime" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 修改到店时间 -->
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_name: "",
        order_id: "",
        state: "",
        order_code: "",
        order_state: "",
        system_order_no: "",
        system_order_status: "",
      },
      // 修改到店时间
      btnLoading: false,
      dialogVisibleModifyLastArrTime: false,
      modifyLastArrTimeForm: {
        order_id: "",
        last_arr_time: "",
      },
      modifyLastArrTimeRules: {
        last_arr_time: [{required: true, message: "到店时间不能为空", trigger: "change"}],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/order/orderList",
        method: "get",
        params: this.listQuery,
      }).then(response => {
        this.list = response.data.items;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    errorRow({row}) {
      let errorStatus = [102, 202];
      if (errorStatus.includes(row.system_order_status) && row.error_order_handle_status === 0) {
        return "error-row";
      }
      return "";
    },
    // 修改到店时间
    handleModifyLastArrTime(row) {
      this.modifyLastArrTimeForm = {
        order_id: row.order_id,
        last_arr_time: "",
      };
      this.dialogVisibleModifyLastArrTime = true;
      this.$nextTick(() => {
        this.$refs["modifyLastArrTimeForm"].clearValidate(); //清除校验结果
      });
    },
    saveDataModifyLastArrTime() {
      this.$refs["modifyLastArrTimeForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/order/modifyLastArrTime",
            method: "post",
            data: this.modifyLastArrTimeForm
          }).then(() => {
            this.dialogVisibleModifyLastArrTime = false;
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    // 重新下单
    handleReOrder(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/reOrder",
          method: "post",
          data: {
            order_id: row.order_id
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    // 取消订单
    handleCancelOrder(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/cancelOrder",
          method: "post",
          data: {
            order_no: row.order_no
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    // 退款
    refund(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/refund",
          method: "post",
          data: {
            order_no: row.order_no
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    // 处理完成
    handleComplete(row) {
      this.$confirm("确认继续该操作", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/order/handleComplete",
          method: "post",
          data: {
            order_id: row.order_id
          }
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功"
          });
        });
      }).catch(() => {
      });
    },
    handleCompleteStatus(row) {
      let errorStatus = [102, 202];
      return !(errorStatus.includes(row.system_order_status) && row.error_order_handle_status === 0)
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
